// @flow
/* eslint-disable no-console */

import configLocal from "./configLocal";
import configProd from "./configProd";
import configDevelop from "./configDevelop";
import configKubernetes from "./configKubernetes";

const getConfig = () => {
  const buildEnv = process.env.NODE_ENV;
  if (buildEnv === "local") {
    console.log("@@@@ build_env = local");
    return configLocal;
  } else if (buildEnv === "develop") {
    console.log("@@@@ build_env = develop");
    return configDevelop;
  } else if (buildEnv === "kubernetes") {
    console.log("@@@ build_env = kubernetes");
    return configKubernetes;
  } else if (buildEnv === "prod") {
    console.log("@@@@ build_env = prod");
    return configProd;
  }
  console.log("@@@@ build_env = kubernetes");
  return configKubernetes; // default develop
};

export default getConfig();



// WEBPACK FOOTER //
// ./app/configs/envConfig.js